<template>
  <intersect @enter="animate = true" :threshold="[0, 0.25, 0.5, 0.75, 1]">
    <section class="head-banner fadeUp" :class="animate ? 'animate' : ''">
      <div class="img-box paralaxe">
        <picture>
          <source
            media="(max-width: 767px)"
            :srcset="_.get(bannerImmage, 'mobile')"
          />
          <source
            media="(max-width: 1023px)"
            :srcset="_.get(bannerImmage, 'tablet')"
          />
          <img
            :src="_.get(bannerImmage, 'desktop')"
            class="img-absolute"
            alt
            v-prlx="{ speed: 0.08 }"
          />
        </picture>
        <div class="img-overlay"></div>
      </div>
      <div class="container banner-content flex-box column">
        <h1 class="main-title white">{{ _.get(itemData, "title") }}</h1>
        <p class="white">{{ _.get(itemData, "teaser") }}</p>
      </div>
    </section>
  </intersect>
</template>
<script>
import Vue from "vue";
import AliMixin from "@/mixins/ali";
import Intersect from "vue-intersect";
import Paralax from "@/assets/js/paralax.js";
Vue.directive("prlx", Paralax);

export default {
  mixins: [AliMixin],
  components: { Intersect },
  props: {
    itemData: Object,
  },
  data() {
    return {
      animate: false,
    };
  },
  mounted() {
    this.startParalaxe();
  },
  computed:{
    bannerImmage(){
      if(_.get(this.itemData, 'cover_image.0.devices'))return this.itemData.cover_image[0].devices;
      if(_.get(this.itemData, 'images.0.devices'))return this.itemData.images[0].devices;
      if(_.get(this.itemData, 'media.cover.devices'))return this.itemData.media.cover.devices;
      return _.get(this.$store.state.selected_menu, 'media.cover.devices');
    }
  }
};
</script>
<style>
.img-box.paralaxe {
  overflow: hidden;
}
</style>


